import { Chip, alpha } from '@mui/material';

/**
 * El vocabulario de flags del sistema de cards. Un flag dice ESTADO
 * OPERACIONAL, nunca un hecho del producto: los hechos (capacidades, specs)
 * van como texto quieto, porque cuando todo es un chip no se lee nada.
 *
 * - `ok`: flexibilidad y certeza (directo, confirmación inmediata, cancela gratis)
 * - `warn`: atención (a confirmar por el operador, quedan pocos, no reembolsable)
 * - `info`: condición informativa (butaca obligatoria, mostrador en terminal)
 * - `neutral`: capacidad del sistema (solo cotización)
 */
export type StatusFlagTone = 'ok' | 'warn' | 'info' | 'neutral';

const TONE_COLOR: Record<StatusFlagTone, 'success' | 'warning' | 'info' | undefined> = {
  ok: 'success',
  warn: 'warning',
  info: 'info',
  neutral: undefined,
};

interface Props {
  tone: StatusFlagTone;
  label: string;
}

/**
 * Tinte suave y sin borde: el flag informa, no compite con el CTA (lo único
 * violeta de la card).
 */
export function StatusFlag({ tone, label }: Props) {
  const color = TONE_COLOR[tone];

  return (
    <Chip
      size="small"
      label={label}
      sx={(theme) => {
        const palette = color ? theme.palette[color] : undefined;
        return {
          height: 21,
          fontSize: 11.5,
          fontWeight: 600,
          border: 0,
          bgcolor: palette
            ? alpha(palette.main, 0.14)
            : alpha(theme.palette.text.primary, 0.08),
          color: palette ? palette.dark : theme.palette.text.secondary,
        };
      }}
    />
  );
}
